import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";
import { fetchMasterList } from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";

const UsersModal = (props) => {
  let [firstName, setFirstName] = useState("");
  let [lastName, setLastName] = useState("");
  let [edit, setEdit] = useState(false);
  let [id, setId] = useState("");
  let [contactNo, setContactNo] = useState("");
  let [pin, setPin] = useState("");
  let [email, setEmail] = useState("");
  let [role, setRole] = useState("");
  let [roleName, setRoleName] = useState("");
  const [validate, setValidate] = useState(false);
  let [status, setStatus] = useState("Active");
  let [qcAccessReq, setQCAccessReq] = useState("No");
  const { t } = useTranslation();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const [roleError, setRoleError] = useState(false);

  const checkInput = (e) => {
    const onlyDigits = e.target.value.replace(/\D/g, "");
    setContactNo(onlyDigits);
  };

  useEffect(() => {
    if (props.data.userId) {
      setFirstName(props?.data?.firstName);
      setLastName(props?.data?.lastName);
      setId(props?.data?.userId);
      setStatus(props?.data?.userStatus);
      setEmail(props?.data?.email);
      setContactNo(props?.data?.contactNumber);
      setRole(props?.data?.category);
      setRoleName(props?.data?.roleName);
      setQCAccessReq(props?.data?.qcAccessReq);
      setPin(props?.data?.pin);
      setEdit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let roleList = useSelector(
    (state) => state?.masterList?.page[Constants.MASTER.ROLE.name]?.data,
  ); // User Details from Store

  useEffect(() => {
    if (!roleList) {
      dispatch(fetchMasterList(Constants.MASTER.ROLE));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleList]);

  const roleResult =
    roleList && roleList.map(({ code, name }) => ({ code, name }));

  const handleSave = (event) => {
    const form = formRef.current;
    if (!role) {
      setRoleError(true);
      return;
    }
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidate(true);
      return;
    } else {
      setValidate(false);
      const userObj = {
        firstName: firstName,
        lastName: lastName,
        userId: id,
        email: email,
        contactNumber: contactNo,
        category: role,
        userStatus: status,
        roleName: roleName,
        qcAccessReq: qcAccessReq,
        pin: pin,
      };
      if (edit) {
        userObj._id = props.data._id;
      }
      props.onSave(userObj, edit);
      setFirstName("");
      setLastName("");
      setContactNo("");
      setEmail("");
      setId("");
      setRole("");
      setEdit(false);
      setRoleName("");
      setQCAccessReq("No");
      setPin("");
    }
  };

  const handleCancel = (event) => {
    setFirstName("");
    setLastName("");
    setContactNo("");
    setEmail("");
    setId("");
    setRole("");
    setRoleName("");
    setQCAccessReq("No");
    setPin("");
    props.onHide();
  };

  const { show, onHide } = props;
  return (
    <Modal show={show} onHide={onHide} animation={false} backdrop="static">
      <ModalHeader
        title={
          edit
            ? t("msg_master_list.msg_user.edit_page_title")
            : t("msg_master_list.msg_user.page_title")
        }
      ></ModalHeader>
      <ModalBody>
        <Form noValidate validated={validate} ref={formRef}>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_user.role")} :
            </Form.Label>
            <DropdownListField
              id="code"
              name="name"
              className="dropdownHive w-full rounded-md"
              data={roleResult}
              value={role}
              onChange={(value) => {
                setRole(value.code);
                setRoleName(value.name);
                setRoleError(false);
              }}
              placeholder={t("msg_master_list.msg_user.select_role")}
              autoFocus={true}
              disabled={props?.data?.category === "ADMIN" ? true : false}
              error={roleError}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_user.id")} :
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g: USER-001"
              value={id || ""}
              disabled={props?.data?.category === "ADMIN" ? true : false}
              onChange={(e) => setId(e.target.value?.trim()?.toUpperCase())}
              required
              maxLength={Constants.MASTER.VALIDATION.maxLengthCode}
              autoFocus
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_user.user_id_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {" "}
              {t("msg_master_list.msg_user.user_first_name")} :
            </Form.Label>
            <Form.Control
              type="text"
              value={firstName || ""}
              onChange={(e) => setFirstName(e.target.value)}
              maxLength={Constants.MASTER.VALIDATION.maxLengthName}
              required
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_user.user_first_name_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {" "}
              {t("msg_master_list.msg_user.user_last_name")} :
            </Form.Label>
            <Form.Control
              type="text"
              value={lastName || ""}
              onChange={(e) => setLastName(e.target.value)}
              maxLength={Constants.MASTER.VALIDATION.maxLengthName}
              required
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_user.user_last_name_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_user.email")} :
            </Form.Label>
            <Form.Control
              type="email"
              placeholder="e.g: user@email.com"
              value={email || ""}
              onChange={(e) => setEmail(e.target.value.trim())}
              isInvalid={validate && !/^\S+@\S+\.\S+$/.test(email)}
              required
              autoFocus
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_user.user_email_validation")}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {" "}
              {t("msg_master_list.msg_user.contactNo")} :
            </Form.Label>
            <Form.Control
              type="tel"
              value={contactNo || ""}
              onChange={(e) => checkInput(e)}
              maxLength={Constants.MASTER.VALIDATION.maxLengthCode}
              required
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_user.user_contact_validation")}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_common.status")} :
            </Form.Label>
            <Form.Select
              aria-label="select status"
              onChange={(e) => setStatus(e.target.value)}
              value={status}
              disabled={props?.data?.category === "ADMIN" ? true : false}
            >
              <option value="Active">{t("msg_common.active")}</option>
              <option value="Inactive">{t("msg_common.inactive")}</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_user.quality_certificate_access")} :
            </Form.Label>
            <Form.Select
              aria-label="select status"
              onChange={(e) => setQCAccessReq(e.target.value)}
              value={qcAccessReq}
            >
              <option value="Yes">{t("msg_common.Yes")}</option>
              <option value="No">{t("msg_common.No")}</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="pin">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_user.pin")} :
            </Form.Label>

            <Form.Control
              type="number"
              inputMode="numeric"
              placeholder="Enter 4 Digit PIN"
              value={pin || ""}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 4);
                setPin(value);
              }}
              maxLength={4}
              required
            />

            <Form.Control.Feedback type="invalid">
              Please enter a valid 4-digit PIN.
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          type="button"
          variant="success"
          className="btn btn-success"
          onClick={handleSave}
        >
          {t("msg_common.save")}
        </Button>
        <Button
          type="button"
          variant="danger"
          className="btn btn-danger"
          onClick={handleCancel}
          data-dismiss="modal"
        >
          {t("msg_common.cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UsersModal;
